module.exports = __webpack_public_path__ + "img/bg_judicial_04.29243a9d.jpg";